var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[(_vm.error)?_c('ww-open-data',{attrs:{"type":_vm.type,"openid":_vm.openid,"default-text":_vm.name||''}}):_c('span',[_vm._v(_vm._s(_vm.name||''))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }